export const getConfig = payload => ({
  baseURL: 'https://api-ip.hotmart.com/',
  endpoints: {
    ip: `/api/ip/info`,
  },
  driver: 'axios',
})
